import { makeSchedulesRepository } from 'shared/infra/repositories';

import { FetchCustomerScheduledSessionsUseCase } from './implementations/FetchCustomerScheduledSessionsUseCase';

let instance: FetchCustomerScheduledSessionsUseCase | null = null;

export default function makeFetchCustomerScheduledSessionsUseCase() {
  if (!instance) {
    const repository = makeSchedulesRepository();

    instance = new FetchCustomerScheduledSessionsUseCase(repository);
  }

  return instance;
}
